module.exports = __webpack_public_path__ + "static/media/ball.1118ef7e.svg";